import type {ReactNode} from "react";
import {NavItem, NavSection} from "~/components/header/collapsed-header/subnavigation/common";
import {Accordion, AccordionItem, AccordionTrigger, AccordionContent} from "~/components/ui/accordion";
import {useTranslation} from "react-i18next";
import {DEVELOPER_DOCS_URL, HELP_CENTER_URL, STATUS_URL} from "~/lib/external-links";
import {useOpenObdCompatibilityChecker} from "~/components/products/pdp/ObdCompatibilityCheckerContext";

export function ResourcesSubSection({ close}: {close: () => void}) {
    const { t } = useTranslation("common");
    const openObdChecker = useOpenObdCompatibilityChecker();

    return <NavSection value="resources" label={t("nav.resources")}>
        <Accordion type="multiple" defaultValue={["resources-support"]}>
            <ResourcesSubSectionContainer value="resources-support" label={t("subnav.resources.col_support")}>
                <NavItem label={t("subnav.resources.help_center")} to={HELP_CENTER_URL} external onClick={close} />
                <NavItem label={t("subnav.resources.system_status")} to={STATUS_URL} external onClick={close} />
                {/* Opens the site-wide Compatibility Checker drawer (mounted in root.tsx). */}
                <NavItem
                    label={t("subnav.resources.find_my_obd_port")}
                    to="#"
                    onClick={(e) => {
                        close();
                        if (!openObdChecker) return;
                        e.preventDefault();
                        openObdChecker();
                    }}
                />
            </ResourcesSubSectionContainer>
            <ResourcesSubSectionContainer value="resources-company" label={t("subnav.resources.col_company")}>
                <NavItem label={t("subnav.resources.blog")} to="https://www.bouncie.com/blog" external onClick={close} />
                <NavItem label={t("subnav.resources.careers")} to="/careers" onClick={close} />
                <NavItem label={t("subnav.resources.collaborate")} to="/big-idea" onClick={close} />
            </ResourcesSubSectionContainer>
            <ResourcesSubSectionContainer value="resources-developers" label={t("subnav.resources.col_developers")}>
                <NavItem label={t("subnav.resources.docs")} to={DEVELOPER_DOCS_URL} external onClick={close} />
                <NavItem label={t("subnav.resources.api")} to={DEVELOPER_DOCS_URL} external onClick={close} />
            </ResourcesSubSectionContainer>
        </Accordion>
    </NavSection>
}

function ResourcesSubSectionContainer({
                             value, label, children,
                         }: {
    value: string; label: string; children: ReactNode;
}) {
    return (
        <AccordionItem value={value} className="border-none">
            <AccordionTrigger data-sid={`nav-collapsed-subtrigger:resources:${value}`} className="py-3 pr-4 pl-10">
                {label}
            </AccordionTrigger>
            <AccordionContent className="p-0">
                {children}
            </AccordionContent>
        </AccordionItem>
    );
}
